// react
import { ReactNode } from 'react';

// mui
import { Box, Grid, Tooltip, Typography, TypographyProps } from '@mui/material';

// props
export interface ListProps {
	items: ReactNode[];
	maxItems?: number;
	TypographyProps?: TypographyProps;
}

export const List = ({ items, maxItems, TypographyProps }: ListProps) => {
	// vars
	let itemsToRender: ReactNode[] = items;
	let itemsLeft: ReactNode[] = [];

	if (maxItems) {
		itemsToRender = items.slice(0, maxItems);
		itemsLeft = items.slice(maxItems);
	}

	return (
		<Grid alignItems="center" container spacing={1}>
			<Grid item xs="auto">
				<Grid container direction="column">
					{itemsToRender.map((item, index) => (
						<Grid item key={`list-item-${index}`}>
							{typeof item === 'string' ? (
								<Typography {...TypographyProps}>{item}</Typography>
							) : (
								item
							)}
						</Grid>
					))}
				</Grid>
			</Grid>
			{itemsLeft.length > 0 && (
				<Grid item xs="auto">
					<Grid alignItems="center" container spacing={0.5}>
						<Grid item>+</Grid>
						<Grid item>
							<Tooltip
								placement="top"
								title={
									<Grid container direction="column">
										{itemsLeft.map((item, index) => (
											<Grid item key={`tooltip-list-item-${index}`}>
												{item}
											</Grid>
										))}
									</Grid>
								}>
								<Box
									sx={(theme) => {
										return {
											backgroundColor: theme.palette.brand.grey[300],
											borderRadius: 13,
											width: 26,
											height: 26,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										};
									}}>
									<Typography fontWeight={600} variant="caption">
										{itemsLeft.length}
									</Typography>
								</Box>
							</Tooltip>
						</Grid>
					</Grid>
				</Grid>
			)}
		</Grid>
	);
};
